let session = {};

export default {
    setSessionValue: (key, value)=> {
        session[key] = value;
    },

    getSessionValue: (key)=> {
        return session[key];
    },

    clearSession: ()=> {
        session = {};
    }
};